(function() {
'use strict';

let allImages = {};

angular
    .module('core')
    .directive('lazySrc', lazySrc);

function lazySrc($window,
        imageService,
        broker,
        $document) {
    const lazyLoader = (() => {
        let images = [];
        let renderTimer = null;
        const renderDelay = 100;
        const win = $($window);
        const doc = $document;
        let documentHeight = doc.height();
        let documentTimer = null;
        const documentDelay = 2000;
        let isWatchingWindow = false;

        function addImage(image) {
            images.push(image);
            if (!renderTimer) {
                startRenderTimer();
            }
            if (!isWatchingWindow) {
                startWatchingWindow();
            }
        }

        function removeImage(image) {
            images = _.reject(images, i => i === image);
            if (!images.length) {
                clearRenderTimer();
                stopWatchingWindow();
            }
        }

        function checkDocumentHeight() {
            if (renderTimer) {
                return;
            }
            const currentDocumentHeight = doc.height();
            if (currentDocumentHeight === documentHeight) {
                return;
            }
            documentHeight = currentDocumentHeight;
            startRenderTimer();
        }

        function checkImages() {
            const windowHeight = win.height();
            const topFoldOffset = win.scrollTop();
            const bottomFoldOffset = (topFoldOffset + windowHeight);

            images = _.filter(images, image => {
                const visible = image.isVisible(topFoldOffset, bottomFoldOffset);
                if (visible) {
                    image.render();
                }
                return !visible;
            });

            clearRenderTimer();

            if (!images.length) {
                stopWatchingWindow();
            }
        }

        function clearRenderTimer() {
            clearTimeout(renderTimer);
            renderTimer = null;
        }

        function startRenderTimer() {
            renderTimer = setTimeout(checkImages, renderDelay);
        }

        function startWatchingWindow() {
            isWatchingWindow = true;
            win.on('resize.lazySrc', windowChanged);
            win.on('scroll.lazySrc', windowChanged);
            documentTimer = setInterval(checkDocumentHeight, documentDelay);
            broker.subscribe('LazySrc', 'LazySrcRetry', windowChanged);
        }

        function stopWatchingWindow() {
            isWatchingWindow = false;
            win.off('resize.lazySrc');
            win.off('scroll.lazySrc');
            clearInterval(documentTimer);
            broker.unsubscribe('LazySrc');
        }

        function windowChanged() {
            if (!renderTimer) {
                startRenderTimer();
            }
        }

        return ({ addImage, removeImage });
    })();


    function LazyImage(element, isFixedSize, isRendered) {
        let source = null;
        let height = null;

        $(element).addClass('lazy-load');

        function isVisible(topFoldOffset, bottomFoldOffset) {
            if (!element.is(':visible')) {
                return false;
            }

            if (height === null) {
                height = element.height();
            }

            const top = element.offset().top;
            const bottom = top + height;

            return (top <= bottomFoldOffset && top >= topFoldOffset) ||
                (bottom <= bottomFoldOffset && bottom >= topFoldOffset) ||
                (top <= topFoldOffset && bottom >= bottomFoldOffset);
        }

        function setSource(newSource) {
            source = newSource;
            if (isRendered) {
                render();
            }
        }

        function render() {
            isRendered ? renderSource() : setTimeout(renderSource);
        }

        function renderSource() {

            const el = element[0];
            if (!isFixedSize) {

                const elWidth = element.outerWidth();
                const elHeight = element.outerHeight();

                let appropWidth;
                let appropHeight;

                source = source.replace(/(width|height)=\d+&?/g, '');
                if (!/\?/.test(source)) {
                    source += '?';
                }

                if (elWidth < 2 || elHeight < 2) {
                    // i.e. a 1x1 placeholder (no `src` fails ':visible' test above)
                    // Use parent width, leave height unspecified
                    appropWidth = elWidth > 2 ? elWidth : 0;
                    appropWidth = appropWidth || element.parent().width() || element.parent().parent().width() || 0;
                } else {
                    // Else add height to the img src string
                    [appropWidth, appropHeight] = imageService.getAppropriateSize(elWidth, elHeight);
                }

                let isRatio16x9 = $(element).is('.sc-c-responsive-image--16x9, .sc-c-responsive-image--16x9 *');
                if (isRatio16x9) {
                    appropHeight = Math.ceil(appropWidth * 9 / 16);
                    source += '&crop=true';
                }

                source += `&width=${appropWidth}`;
                if (appropHeight) {
                    source += `&height=${appropHeight}`;
                }
                source = source.replace(/\?&+/g, '?');
                source = source.replace(/&&+/g, '&');
            }
            if (isRendered) {
                addSourceToElement(el, source);
            } else {
                // preload the image before we set the src (for smooth fade in)
                const image = new Image();
                image.onload = () => addSourceToElement(el, source);
                image.src = source;
            }
            isRendered = true;
        }

        function addSourceToElement(el, source) {
            if (el.tagName.toUpperCase() === 'IMG') {
                el.src = source;
            } else {
                el.style.backgroundImage = `url(${source})`;
            }
            $(el).addClass('lazy-loaded');
        }

        return ({ isVisible, render, setSource });
    }

    function link($scope, element, attributes) {
        let isRendered = (function() {
            if (attributes.lazySrcIsPrerender === 'true') {
                return true;
            }
            if (attributes.lazySrcIsPrerender === 'false') {
                return false;
            }
            if (attributes.lazySrc && allImages[attributes.lazySrc]) {
                return true;
            }
            return TRPCONFIG.IsPrerender;
        })();
        allImages[attributes.lazySrc] = true;
        let isFixedSize = attributes.lazySrcFixedSize === 'true';
        const lazyImage = new LazyImage(element, isFixedSize, isRendered);
        lazyLoader.addImage(lazyImage);
        attributes.$observe('lazySrc', newSource => lazyImage.setSource(newSource));
        $scope.$on('$destroy', () => lazyLoader.removeImage(lazyImage));
    }

    return ({ link, restrict: 'A' });
}
})();
